module.exports = __webpack_public_path__ + "static/img/hero-2.be68286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-2.jpg
// module id = 9qrI
// module chunks = 0